// extracted by mini-css-extract-plugin
export var outlineDark = "Button-module--outlineDark--5aff8";
export var outlineLight = "Button-module--outlineLight--ab51c";